import { z } from "zod";

// 再利用可能な URLGroupPatternType 定義とラベル（GraphQL enumに対応）
export const urlGroupPatternTypeEnum = z.enum([
  "CONTAINS",
  "INCLUDES",
  "NOT_INCLUDES",
  "NOT_CONTAINS",
  "STARTS_WITH",
  "ENDS_WITH",
  "EQUALS",
  "REGEX",
  "NOT_REGEX",
  "SUB_DOMAIN",
  "DEPTH1",
  "DEPTH2",
  "DEPTH3",
]);

export type URLGroupPatternType = z.infer<typeof urlGroupPatternTypeEnum>;
